import * as React from 'react';
import { Control } from 'react-redux-form';

export interface IFormInputProps {
    type: string;
    placeholder: string;
    onChange?: (e) => void;
    model?: string;
    defaultValue?: string;
}

export interface IFormInputState {
    value: string;
}

export class FormInput extends React.PureComponent<IFormInputProps, IFormInputState> {
    constructor(props: IFormInputProps) {
        super(props);
        this.state = { value: '' };
    }

    componentWillReceiveProps(nextProps: IFormInputProps) {
        if (nextProps.defaultValue && !this.state.value) {
            this.setState({
                value : nextProps.defaultValue
            });
        }
    }

    render() {
        const { model, placeholder, type } = this.props;
        return <div className="form-input">
            <div className=" input-field" >
                <Control.text
                    type={type}
                    value={this.state.value}
                    model={model}
                    onChange={e => this.setState({ value: e.target['value'] })}
                    className={`form-control`}
                    placeholder={placeholder}
                />
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/FormInput.tsx